import React from 'react';

import { useHistory } from 'react-router';

import { PlusOutlined } from '@ant-design/icons';
import { TenantFeature } from '@recurrency/core-api';

import { shouldShowFeatureFlag } from 'contexts/Auth0Context';

import { Button } from 'components/Button';

import { useGlobalApp } from 'hooks/useGlobalApp';

import { routes } from 'utils/routes';
import { track, TrackEvent, CtaName, CtaType } from 'utils/track';

export const NewProspectButton = () => {
  const history = useHistory();
  const { activeTenant, activeUser } = useGlobalApp();

  const newProspect = () => {
    track(TrackEvent.Nav_CtaClick, {
      ctaName: CtaName.NewProspect,
      ctaType: CtaType.Button,
    });
    history.push(routes.sales.customerNew());
  };
  return shouldShowFeatureFlag(activeTenant, activeUser, TenantFeature.SalesCreateProspect) ? (
    <Button type="primary" onClick={newProspect}>
      <PlusOutlined /> New Prospect
    </Button>
  ) : null;
};
